module.exports = __webpack_public_path__ + "static/media/sleepyDragonz.62a7d402.png";